// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__uC05K","tab__item":"tabs_tab__item__yYZkg","active":"tabs_active__3q4ed","badge":"tabs_badge__CDuIf"};